import React from 'react';
import PropTypes from 'prop-types';
import Button from 'zignal-landscape/lib/Button';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';

import styles from './DuplicateCodingMenuBody.css';

class DuplicateCodingMenuBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedProfiles: [],
    };

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleAllProfilesChange = this.handleAllProfilesChange.bind(this);
    this.handleSaveAndApply = this.handleSaveAndApply.bind(this);

    this.handleSelectOnlyOneClick = this.handleSelectOnlyOneClick.bind(this);
  }

  getFullProfileName(profile) {
    if (profile.isProfileOutsideActiveCampaign) {
      return (
        <span className={styles.titleText}>{profile.name}<small>&nbsp;{profile.campaignTitle}</small></span>
      );
    }
    return <span className={styles.titleText}>{profile.name}</span>;
  }

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.setState({
      selectedProfiles: this.props.profiles.map((profile) => profile.id),
    });
  }

  handleCheckboxChange(e) {
    const value = e.target.value;
    if (this.state.selectedProfiles.indexOf(value) > -1) {
      const selectedProfiles = this.state.selectedProfiles;
      selectedProfiles.splice(selectedProfiles.indexOf(value), 1);
      this.setState({
        selectedProfiles,
      });
    } else {
      this.setState({
        selectedProfiles: [...this.state.selectedProfiles, value],
      });
    }
  }

  handleAllProfilesChange() {
    const { profiles } = this.props;
    if (profiles.length === this.state.selectedProfiles.length) {
      this.setState({ selectedProfiles: [] });
    } else {
      this.setState({ selectedProfiles: profiles.map((profile) => profile.id) });
    }
  }

  handleSaveAndApply() {
    this.props.onSaveAndApply(this.props.profileId, this.state.selectedProfiles);
  }

  handleSelectOnlyOneClick(e, profileId) {
    e.stopPropagation();
    this.setState({
      selectedProfiles: [profileId],
    });
  }

  render() {
    const { profiles } = this.props;
    return (
      <div>
        <div className={styles.dropdownHeader}>
          Copy all values to
        </div>
        <div className={styles.dropdownBody}>
          <div>
            <Checkbox
              id="all_profiles"
              onChange={this.handleAllProfilesChange}
              checked={this.state.selectedProfiles.length === profiles.length}
            />
            <Label
              htmlFor="all_profiles"
              inline
              onChange={this.handleAllProfilesChange}
            >
              All Datasets
            </Label>
          </div>
          <div className={styles.horizontalSeparator} />
          {profiles.map((profile, index) => (
            <div className={styles.checkboxItem} key={profile.id}>
              <Checkbox
                id={`profile_id_${index}`}
                name="profiles[]"
                value={profile.id}
                size="normal"
                onChange={this.handleCheckboxChange}
                checked={this.state.selectedProfiles.indexOf(profile.id) > -1}
              />
              <Label
                htmlFor={`profile_id_${index}`}
                inline
              >
                <div className={styles.profileTitle}>
                  {this.getFullProfileName(profile)}
                  <button
                    onClick={(e) => { this.handleSelectOnlyOneClick(e, profile.id); }}
                    className={styles.selectOnly}
                  >
                    Only
                  </button>
                </div>
              </Label>
            </div>
          ))}
        </div>
        <div className={styles.dropdownFooter}>
          <div className={styles.horizontalSeparator} />
          <Button buttonStyle="positive" onClick={this.handleSaveAndApply}>Apply & Save</Button>
        </div>
      </div>
    );
  }
}

DuplicateCodingMenuBody.propTypes = {
  profiles: PropTypes.array.isRequired,
  profileId: PropTypes.string.isRequired,
  onSaveAndApply: PropTypes.func.isRequired,
};


export default DuplicateCodingMenuBody;
